// Supported languages, shared by the Worker (room/word language) and web/ (UI language).

export const LANGS = ["en", "es"] as const;
export type Lang = (typeof LANGS)[number];

/** Primary language: used when nothing better is known. */
export const DEFAULT_LANG: Lang = "en";

export function isLang(value: unknown): value is Lang {
  return typeof value === "string" && (LANGS as readonly string[]).includes(value);
}

/**
 * Picks the UI language: an explicit stored choice wins, then the first supported entry of
 * the browser's preferred languages (e.g. "es-MX" → "es"), then DEFAULT_LANG.
 */
export function resolveLang(stored: string | null, preferred: readonly string[]): Lang {
  if (isLang(stored)) return stored;
  for (const tag of preferred) {
    const base = tag.toLowerCase().split("-")[0];
    if (isLang(base)) return base;
  }
  return DEFAULT_LANG;
}
